export const mergeCategoriesData = (apiData, dummyData) => {
    return apiData.map(apiCat => {
        const dummyCat = dummyData.find(c => c.id === apiCat.categoryId);
        return {
            ...apiCat,
            id: apiCat.categoryId,
            name: apiCat.categoryName,
            description: dummyCat?.description || 'No description available',
            icon: dummyCat?.icon || 'FolderOpen',
            color: dummyCat?.color || '#64748b',
            gradient: dummyCat?.gradient || 'linear-gradient(135deg, #64748b, #475569)',
            tag: dummyCat?.tag || 'Uncategorized',
            totalProject: apiCat.totalProject,
            activeProject: apiCat.activeProject,
        };
    });
}